module.exports = __webpack_public_path__ + "img/templeofptah_tech_Normal_ua.f2bf7013.webp";